// extracted by mini-css-extract-plugin
export default {"battle":"Battle_battle__jmHFL","leftPanel":"Battle_leftPanel__ohqvC","centerPanel":"Battle_centerPanel__4J7Hv","rightPanel":"Battle_rightPanel__ILd2z"};